import type { ReportReason } from '@/api/types'
import type { MessageKey } from '@/i18n'

/** 举报理由的名字与一句话说明。举报框和管理队列共用 */
export const REASON_TEXT: Record<ReportReason, { label: MessageKey; description: MessageKey }> = {
  spam: { label: 'report.spam', description: 'report.spamDesc' },
  abuse: { label: 'report.abuse', description: 'report.abuseDesc' },
  impersonation: { label: 'report.impersonation', description: 'report.impersonationDesc' },
  sensitive: { label: 'report.sensitive', description: 'report.sensitiveDesc' },
  illegal: { label: 'report.illegal', description: 'report.illegalDesc' },
  other: { label: 'report.otherReason', description: 'report.otherDesc' },
}

export function reasonLabel(reason: ReportReason): MessageKey {
  return REASON_TEXT[reason].label
}
